import { render } from "./ListeReglementGroupePage.vue?vue&type=template&id=3cb76c4c&ts=true"
import script from "./ListeReglementGroupePage.vue?vue&type=script&lang=ts"
export * from "./ListeReglementGroupePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__